export { default as documentObjectIconMap } from "./documentObjectIconId.iconMap";
